// extracted by mini-css-extract-plugin
module.exports = {"contain":"_ceac433","header":"_4eec8d9","grid":"_03437e2","col2":"_bc37a1c","col3":"_a405d71","col4":"_470c70e"};